module.exports = __webpack_public_path__ + "img/9788936434267.af88cbbc.jpg";